import axios from 'axios'

class AdvertisementsService {
  getAdvertisements = (params) =>
    axios({
      url: 'advertisements/admin/list',
      method: 'GET',
      params,
    })

  getAdvertisementById = (id) =>
    axios({
      url: `advertisements/admin/${id}`,
      method: 'GET',
    })

  createAdvertisement = (data) =>
    axios({
      url: 'advertisements/admin',
      method: 'POST',
      data,
    })

  updateAdvertisement = (id, data) =>
    axios({
      url: `advertisements/admin/${id}`,
      method: 'PUT',
      data,
    })

  deleteAdvertisement = (id) =>
    axios({
      url: `advertisements/admin/${id}`,
      method: 'DELETE',
    })
}

export default new AdvertisementsService()
